import { render, staticRenderFns } from "./OwalTransitionSlide.vue?vue&type=template&id=383ebf73&scoped=true"
import script from "./OwalTransitionSlide.vue?vue&type=script&lang=js"
export * from "./OwalTransitionSlide.vue?vue&type=script&lang=js"
import style0 from "./OwalTransitionSlide.vue?vue&type=style&index=0&id=383ebf73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383ebf73",
  null
  
)

export default component.exports